import React from "react";
import theme from "../../../styles/theme";



const Page55 = () => {
  return (
    <div>
    <h2>"Page 55" </h2>
    </div>

  );
};

export default Page55;
